import React, { useState } from "react";
import cn from "classnames";
import SvgIcon from "../../../../common/components/svg-icon";

const DatePicker = ({ id, title, hint, initValue, onChange, errors }) => {
  const [ val, setVal ] = useState(initValue || '');

  const handleOnChange = (event) => {
    setVal(event.target.value);
    onChange(event.target.value);
  };

  return (
    <div className="form_section">
      <div className="form_section-title -grid">
        <div className="form_section-title-item">
          <h3>{title}</h3>
        </div>
        {hint &&
          <div className="form_section-title-item">
            <div className="info-tooltip">
              <div className="info-tooltip_control">
                <SvgIcon name="i-info" />
              </div>
              <div className="info-tooltip_drop">
                <div className="info-tooltip_drop-inner">
                  {hint}
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div className={ cn("form-group", errors ? 'has-error' : '') }>
        <input
          type="date"
          id={ `-js-${id || ''}` }
          className="form-field -block"
          value={ val }
          onChange={ handleOnChange }
        />
      </div>
    </div>
  );
};

export default DatePicker;
